import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'opm-modal-popup',
  templateUrl: './modal-popup.component.html',
  styleUrls: ['./modal-popup.component.less'],
  standalone: false
})
export class ModalPopupComponent implements OnInit, AfterViewInit {

  @Input() message: string;
  @Input() header: string;
  @Input() cancelVisibility: boolean = true;
  @Input() okButtonName: string;
  @Output() onOk: EventEmitter<any> = new EventEmitter();
  @Output() onCancel: EventEmitter<any> = new EventEmitter();

  @ViewChild('okButton') firstNameElement: ElementRef;

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.firstNameElement.nativeElement.focus();
  }

  cancel(): void {
    this.onCancel.emit();
  }

  ok(): void {
    this.onOk.emit();
  }
}
